import { MemoizedSelector, createFeatureSelector } from '@ngrx/store';
import { ANONYMOUS_CONSENTS_STORE_FEATURE } from '@spartacus/core';
import { AnonymousConsentsState, StateWithAnonymousConsents } from '../anonymous-consents-state';

export const getAnonymousConsentState: MemoizedSelector<StateWithAnonymousConsents, AnonymousConsentsState> =
  createFeatureSelector<AnonymousConsentsState>(ANONYMOUS_CONSENTS_STORE_FEATURE);
